module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "om-dropdown"
  }, [_c('div', {
    staticClass: "om-dropdown__label",
    class: {
      'is-open': _vm.reveal
    },
    on: {
      "click": function($event) {
        _vm.reveal = !_vm.reveal
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.choosedLabel ? _vm.choosedLabel : _vm.defaultLabel) + "\n  ")]), _vm._v(" "), (_vm.reveal) ? _c('div', {
    staticClass: "om-dropdown__clickout",
    on: {
      "click": function($event) {
        _vm.reveal = !_vm.reveal
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [(_vm.reveal) ? _c('ul', {
    staticClass: "om-dropdown__list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "om-dropdown__item",
      class: {
        'active': _vm.choosedValue === item.value
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeAction(item.value, typeof item.name !== 'undefined' ? item.name : item.value)
        }
      }
    }, [(typeof item.name !== 'undefined') ? _c('span', {
      staticClass: "a"
    }, [_vm._v(_vm._s(item.name))]) : (typeof item.value !== 'undefined') ? _c('span', {
      staticClass: "b"
    }, [_vm._v(_vm._s(item.value))]) : _vm._e()])
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0219fcc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/dropdown/Dropdown.vue
// module id = 276
// module chunks = 1